import { render, staticRenderFns } from "./peosonalDetail.vue?vue&type=template&id=f0088fce&scoped=true"
import script from "./peosonalDetail.vue?vue&type=script&lang=js"
export * from "./peosonalDetail.vue?vue&type=script&lang=js"
import style0 from "./peosonalDetail.vue?vue&type=style&index=0&id=f0088fce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0088fce",
  null
  
)

export default component.exports